import styled from "styled-components";

export const StyledButton = styled.button<{width?: number}>`
  position: relative;
  background-color: #000000;
  color: #ffffff;
  width: ${(props) => props.width ? `${props.width}px` : '100%'};
  padding: 12px;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: rgba(0,0,0,0.8);
  }
  &:active {
    background-color: rgba(0,0,0,0.95);
  }

  &.disabled {
    cursor: default;
    background-color: rgba(0,0,0,0.6);
  }
`